module.exports = __webpack_public_path__ + "static/media/star.fd5de65c.svg";